import createState$ from "./state";
import createEntity$ from "./entity";
import createHovers$ from "./hovers";
import { createGetMaterial$ } from "./material";

const createStreams = (store) => {
  const state$ = createState$(store);
  const entity$ = createEntity$(state$);
  const hovers$ = createHovers$(state$);
  const getMaterial$ = createGetMaterial$(state$);

  return {
    state$,
    entity$,
    hovers$,
    getMaterial$,
  };
};

export default createStreams;
